import dadosCadastraisRotas from './dadoscadastrais/DadosCadastraisRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'
import dirfsRotas from './dirfs/DirfsRotas'
import usuariosRotas from './usuarios/UsuariosRotas'
import contratosRotas from './contratos/ContratosRotas'
import contratosPagamentosRotas from './contratos/pagamentos/PagamentosRotas'
import certidoesRotas from './certidoes/CertidoesRotas'

export default {
    path: 'fornecedor',
    name: 'Fornecedor',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        dadosCadastraisRotas,
        pagamentosRotas,
        dirfsRotas,
        usuariosRotas,
        contratosRotas,
        contratosPagamentosRotas,
        certidoesRotas
    ]
}
